import { Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

function Countdown() {
  const [countdownMessage, setCountdownMessage] = useState("");

  useEffect(() => {
    const calculateCountdown = () => {
      const weddingDate = new Date("2026-07-04T00:00:00");
      const today = new Date();

      // Reset time to midnight for accurate day comparison
      today.setHours(0, 0, 0, 0);
      weddingDate.setHours(0, 0, 0, 0);

      const diffTime = weddingDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 0) {
        setCountdownMessage(
          `FALTAM ${diffDays} ${diffDays === 1 ? "DIA" : "DIAS"}!`,
        );
      } else if (diffDays === 0) {
        setCountdownMessage("HOJE É O GRANDE DIA!");
      } else {
        setCountdownMessage(
          "MUITO OBRIGADO POR TEREM FEITO PARTE DESTE NOSSO DIA!",
        );
      }
    };

    calculateCountdown();
    // Update daily
    const interval = setInterval(calculateCountdown, 1000 * 60 * 60 * 24);

    return () => clearInterval(interval);
  }, []);

  return (
    <Typography
      component={motion.p}
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
      variant="body1"
      sx={{
        fontFamily: '"Open Sans", sans-serif',
        fontSize: { xs: "0.875rem", sm: "1rem" },
        fontWeight: 400,
        /* fontStyle: "", */
        color: "#2d4e66",
        letterSpacing: "0.5px",
        mb: 4,
      }}
    >
      {countdownMessage}
    </Typography>
  );
}

export default Countdown;
